import type { BlockExport } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { Blockquote } from "./Blockquote";
import { defaultData } from "./BlockquoteDefaultData";
import { meta } from "./BlockquoteMetaData";

export const BlockquoteBlock: BlockExport = {
  type: "component",
  Block: Blockquote,
  imagePreview: {
    type: "icon",
    name: "24-builder-ui-element-quote",
    size: 24,
  },
  defaultData,
  meta,
};
